export function GetSlugAndParamsFromNext(url = window.location.href) {
    try {
        const params = new URL(url).searchParams;
        const next = params.get("next");
        if (!next) return  { srcPage: "", fullPath: next, params: "" } // No `next` parameter
        // Avoid null error
        // if (!next) return null; // No `next` parameter

        // Separate the path and query inside `next`
        const [path, queryString] = next.replace(/^\//, "").split("?");
        const srcPage = path.split("/")[0]; // First segment

        // Parse the inner query string
        const innerParams = {};
        if (queryString) {
            const searchParams = new URLSearchParams(queryString);
            for (const [key, value] of searchParams.entries()) {
                innerParams[key] = value;
            }
        }

        return { srcPage, fullPath: next.replace(/^\//, ""), params: innerParams };
    } catch (e) {
        console.error("Invalid URL:", e);
        return null;
    }
}

export function GenerateThreeNonZeroRandoms() {
  const nums = [];
  while (nums.length < 3) {
    const rand = Math.floor(Math.random() * 9) + 1; // 1 to 9
    if (!nums.includes(rand)) {
      nums.push(rand);
    }
  }
  return nums;
}


export function GenerateThreeNonZeroRandomsNew() {
  const nums = new Set();
  while (nums.size < 3) {
    const rand = Math.floor(Math.random() * 9) + 1; // Generates number from 1 to 9
    nums.add(rand);
  }
  return Array.from(nums);
}